import { render } from "./PasswordForget.vue?vue&type=template&id=abe6e978&scoped=true"
import script from "./PasswordForget.vue?vue&type=script&lang=js"
export * from "./PasswordForget.vue?vue&type=script&lang=js"

import "./PasswordForget.vue?vue&type=style&index=0&id=abe6e978&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe6e978"]])

export default __exports__